import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardRoutes from './dashboard'
import AdminRoutes from './admin'
import WriterRoutes from './writer'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import(/* webpackChunkName: "main" */ '../views/Main.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/auth/Register.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/auth/ForgotPassword.vue')
  },
  {
    path: '/verify-email/:token',
    name: 'verify-email',
    component: () => import(/* webpackChunkName: "verify-email" */ '../views/auth/VerifyEmail.vue')
  },
  {
    path: '/recover-account/:token',
    name: 'recover-account',
    component: () => import(/* webpackChunkName: "recover-account" */ '../views/auth/RecoverAccount.vue')
  },
  {
    path: '/invited-user/:token',
    name: 'invited-user',
    component: () => import(/* webpackChunkName: "invited-user" */ '../views/auth/InvitedUser.vue')
  },
  {
    path: '/quote',
    name: 'quote',
    component: () => import(/* webpackChunkName: "quote" */ '../views/order/Quote.vue')
  },
  {
    path: '/place-order',
    name: 'place-order',
    component: () => import(/* webpackChunkName: "place-order" */ '../views/order/Create.vue')
  },
  {
    path: '/place-order/pay',
    name: 'pay-order',
    component: () => import(/* webpackChunkName: "place-order" */ '../views/order/Payment.vue')
  },
  {
    path: '/place-order/success/:id',
    name: 'success-order',
    component: () => import(/* webpackChunkName: "place-order" */ '../views/order/Success.vue')
  },
  {
    path: '/dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    children: DashboardRoutes
  },
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
    children: AdminRoutes
  },
  {
    path: '/writer',
    component: () => import(/* webpackChunkName: "writer" */ '../views/Writer.vue'),
    children: WriterRoutes
  },
  {
    path: '/*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
		return { x: 0, y: 0 };
	},
  routes
})

export default router
